import { ArrowRight } from 'lucide-react';
import { Reveal } from './Reveal';
import { IMAGES, scrollToId } from '../config/site';

// Full photograph preserved — no cover-cropping of the dog on any screen size.
export const Emotional = () => (
  <section className="ks-emotional relative overflow-hidden py-20 lg:py-28" aria-label="The feeling of a clean home">
    <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <Reveal>
        <img
          src={IMAGES.emotionalLiving}
          alt="A small dog resting peacefully on the sofa of a bright, clean, sunlit living room with houseplants"
          className="h-auto w-full rounded-[2.5rem] shadow-lift"
          loading="lazy"
          data-testid="emotional-image"
        />
      </Reveal>

      <Reveal delay={0.1}>
        <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
          Come Home to <span className="text-aqua">Clean.</span>
        </h2>
        <p className="mt-5 max-w-lg text-base leading-relaxed text-white/85 sm:text-lg">
          Less time cleaning. More time enjoying your home, your family and your life.
        </p>
        <button
          type="button"
          data-testid="emotional-quote-button"
          onClick={() => scrollToId('quote')}
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-4 text-base font-bold text-navy transition-colors hover:bg-aqua"
        >
          Get a Free Quote
          <ArrowRight size={17} className="transition-transform duration-300 hover:translate-x-1" />
        </button>
      </Reveal>
    </div>
  </section>
);

export default Emotional;
